<template>
  <v-app>
      <router-view class="ma-0 pa-0"></router-view>
  </v-app>
</template>

<script>
export default {
  components: {
  },
  data: () => ({
  }),
};
</script>

<style scoped>

</style>

